import { useUserEventLogger } from '@repo/tracking-service';
import { Title, useToast } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { FormEventHandler } from 'react';
import { useMutation } from 'react-relay';

import { passwordUpdateMutation } from '@/__generated__/passwordUpdateMutation.graphql';
import { useChangePasswordContext } from '@/components/my/password/contexts/ChangePasswordProvider';
import { usePasswordError } from '@/components/my/password/hooks/use-password-error';
import { NewPasswordCTA } from '@/components/my/password/new-password/NewPasswordCta';
import { ConfirmPasswordInput, NewPasswordInput } from '@/components/my/password/new-password/password-input';
import { updatePasswordQuery } from '@/graphql/query/my/password';
import { MY_PAGE_PATHS } from '@/lib/constants/paths';

export const NewPasswordForm = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { confirmPassword } = useChangePasswordContext();
  const { unknownErrorToast } = usePasswordError();
  const router = useRouter();
  const [updatePassword, isLoading] = useMutation<passwordUpdateMutation>(updatePasswordQuery);
  const toast = useToast();

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    sendClickEvent('pw-change_bottom_complete');

    updatePassword({
      variables: { password: confirmPassword },
      onCompleted: (res) => {
        if (res.updateRefundUserPassword.result) {
          toast({ content: '비밀번호가 변경되었어요.', icon: 'check-mark', iconColor: 'green.600' });
          router.push(MY_PAGE_PATHS.내정보);
          return;
        }
        unknownErrorToast();
      },
      onError: () => {
        unknownErrorToast();
      }
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <section className={'px-4.5'}>
        <Title.Headline title={'변경하고자 하는\n새로운 비밀번호를 입력해주세요'} size={'large'} />

        <NewPasswordInput />
        <ConfirmPasswordInput />
      </section>

      <NewPasswordCTA disabled={isLoading} />
    </form>
  );
};
